
export const lockOverflow = () => {
  if (document) { document.body.style.overflowY = 'hidden' }
}

export const unlockOverflow = () => {
  if (document) { document.body.style.overflowY = 'auto' }
}
